import { useInvoices } from '@/api/ads/hooks';
import { PageHeader } from '@/components/PageHeader';
import { Card, CardBody } from '@/components/ui/card';
import { Table, Th, Td, EmptyRow } from '@/components/ui/table';
import { Spinner } from '@/components/ui/spinner';
import { npr, fmtDateTime } from '@/lib/format';

export function InvoicesPage() {
  const { data, isLoading } = useInvoices();
  return (
    <>
      <PageHeader title="Invoices" description="Issued when a booking is approved and charged." />
      <Card>
        <CardBody className="p-0">
          {isLoading ? (
            <div className="p-6">
              <Spinner label="Loading invoices…" />
            </div>
          ) : (
            <Table>
              <thead>
                <tr>
                  <Th>Number</Th>
                  <Th>Amount</Th>
                  <Th>Booking</Th>
                  <Th>Issued</Th>
                </tr>
              </thead>
              <tbody>
                {(data?.results.length ?? 0) === 0 && <EmptyRow colSpan={4}>No invoices yet.</EmptyRow>}
                {data?.results.map((inv) => (
                  <tr key={inv.id}>
                    <Td className="font-medium">{inv.number}</Td>
                    <Td>{npr(inv.amount)}</Td>
                    <Td className="text-muted-foreground">{inv.booking ? `#${inv.booking}` : '—'}</Td>
                    <Td className="text-muted-foreground">{fmtDateTime(inv.issued_at)}</Td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </CardBody>
      </Card>
    </>
  );
}
